var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNanoFactoringProductIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1973_12287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4177 17.9094C19.7152 17.9094 19.9565 18.1506 19.9565 18.4482V36.5875C19.9565 41.1384 23.632 44.8489 28.1922 44.8489H35.7161H37.1977C37.4953 44.8489 37.7365 45.0901 37.7365 45.3877V45.9265C37.7365 48.9021 35.3243 51.3143 32.3486 51.3143H30.3282H24.9403H17.4165C14.3558 51.3143 11.8746 48.8217 11.8746 45.7469V23.4769C11.8746 20.4021 14.3558 17.9094 17.4165 17.9094H19.4177Z",
    fill: "url(#paint0_linear_1973_12287)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6506 14.3174C22.6506 11.2426 25.1318 8.74994 28.1925 8.74994H36.9806C38.4504 8.74994 39.86 9.33651 40.8993 10.3806L43.8943 13.3895L46.8893 16.3984C47.9286 17.4425 48.5125 18.8586 48.5125 20.3352V36.767C48.5125 39.7426 46.1003 42.1549 43.1246 42.1549H41.1042H35.7163H28.1925C25.1318 42.1549 22.6506 39.6622 22.6506 36.5874V14.3174ZM42.7307 26.627C43.4538 25.8775 43.4324 24.6837 42.6829 23.9606C41.9333 23.2375 40.7395 23.2589 40.0164 24.0084L34.3563 29.8753L31.2814 26.6882C30.5583 25.9386 29.3645 25.9172 28.615 26.6403C27.8655 27.3634 27.844 28.5572 28.5672 29.3068L32.4175 33.2978C33.4768 34.3958 35.2357 34.3958 36.295 33.2978L42.7307 26.627Z",
    fill: "#F43454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1973_12287",
    x: 9.87463,
    y: 7.74994,
    width: 40.6378,
    height: 46.5644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1973_12287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1973_12287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1973_12287",
    x1: 25.9371,
    y1: 18.125,
    x2: 15.0044,
    y2: 49.8507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#65408A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#3E4CB4"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNanoFactoringProductIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nano-factoring-product-icon.bed9f7c2.svg";
export { ForwardRef as ReactComponent };